const FaceCharacters = () => {
	return <h1>FaceCharacters</h1>;
  };
  
  export default FaceCharacters;